import React, { createContext, useCallback, useContext, useState } from "react";
import { useMainContext } from "../../../context";
import { Navigate, useNavigate } from "react-router-dom";
import MaskMoney from "../../../utils/maskMoney";
import API, { createTempAccount } from "../../../api";
import { MaskPhone } from "../../../utils/masks";
import { getSocket } from "../../../services/socket_service";
import { getDeliveryPriceByCep } from "../../../services/getAddressByCEP";
import { LocalService, SessionService } from "../../../services/persistService";
import { ROUTES } from "../../../routes";
import { useMemo } from "react";
import { toast } from "react-toastify";

export const CartContext = createContext({});

export const CartProvider = ({ children }) => {
  const navigate = useNavigate();

  const [loadingCreateOrder, setLoadingCreateOrder] = useState(false);
  const [thing, setThing] = useState("R$ 0");
  const [confirmDestroy, setConfirmDestroy] = useState(false);
  const [textConfirm, setTextConfirm] = useState("");
  const [funcConfirm, setFuncConfirm] = useState("item");
  const [posItemSelected, setPosItemSelected] = useState(0);
  const [controlRender, setControlRender] = useState(false);
  const [name, setName] = useState("");
  const [phone, editPhone] = useState("");
  const {
    order,
    setOrder,
    products,
    setItem,
    setProduct,
    setPosItem,
    address,
    restaurant,
    setShowCart,
    restaurantDeliveryPrice,
    setRestaurantDeliveryPrice,
    setIsOrderFinishedSuccess,
    restaurantId,
    settings,
  } = useMainContext();

  const calcChooses = useCallback(
    (indexItem, indexRequired) => {
      let chooses = 0;
      order?.items[indexItem].product.requireds[
        indexRequired
      ].groupsOptions.forEach((group) => {
        group.options.forEach((option) => {
          if (option.selected) chooses++;
        });
      });
      return chooses;
    },
    [order],
  );

  const clickToEdit = useCallback(
    (editItem, posItem) => {
      setPosItem(posItem);
      setItem({ ...editItem });
      const editProduct = products.find(
        (product) => product.id === editItem.product_id,
      );
      setProduct({ ...editProduct });
      Navigate(`/order-edit`);
    },
    [products],
  );

  const calcItem = useCallback(
    (item, indexItem) => {
      if (item.product.category.price_method == 2) {
        let totalPrice = order?.items[indexItem].product.price
          ? order.items[indexItem].product.price
          : 0;
        order?.items[indexItem].product.requireds.forEach(
          (required, indexRequired) => {
            required.groupsOptions.forEach((group) => {
              if (!group.special_type) {
                //remove !
                group.options.forEach((option) => {
                  if (option.quantity != null && option.quantity != 0) {
                    totalPrice += option.price
                      ? option.price * option.quantity
                      : 0;
                  }
                });
              }
            });
          },
        );
        order?.items[indexItem].product.groupsAdditionals.forEach((group) => {
          group.additionals.forEach((additional) => {
            if (additional.selected)
              totalPrice += additional.price ? additional.price : 0;
          });
        });
        return totalPrice;
      } else {
        let totalPrice = order?.items[indexItem].product.price
          ? order.items[indexItem].product.price
          : 0;
        order?.items[indexItem].product.requireds.forEach((required) => {
          required.groupsOptions.forEach((group) => {
            group.options.forEach((option) => {
              if (option.selected)
                totalPrice += option.price ? option.price : 0;
            });
          });
        });
        order?.items[indexItem].product.groupsAdditionals.forEach((group) => {
          group.additionals.forEach((additional) => {
            if (additional.selected)
              totalPrice += additional.price ? additional.price : 0;
          });
        });
        return totalPrice;
      }
    },
    [order],
  );

  const totalOrderValue = useMemo(() => {
    let priceTotal = 0;

    order?.items.forEach((item, indexItem) => {
      priceTotal += calcItem(item, indexItem) * item.qnt;
    });

    if (order?.withdrawal === "delivery") {
      priceTotal += parseFloat(restaurantDeliveryPrice ?? 0);
    }

    if (order?.useCashback) {
      priceTotal -= restaurant.balance.points_balance;
    }

    return priceTotal;
  }, [order, restaurant, restaurantDeliveryPrice]);

  const calcOrderProductsValue = useCallback(() => {
    let priceTotal = 0;
    order?.items.forEach((item, indexItem) => {
      priceTotal += calcItem(item, indexItem) * item.qnt;
    });
    return priceTotal;
  }, [order, restaurant]);

  const deliveryType = useMemo(() => order?.withdrawal, [order]);

  const setDeliveryType = useCallback((newType) => {
    setOrder((atualOrder) => {
      if (atualOrder) {
        const newOrder = atualOrder;
        newOrder.withdrawal = newType;
        return { ...newOrder };
      }
      return atualOrder;
    });
    if (newType === "balcony") setDefaultDataForBalcony();
  }, []);

  const changePayMethod = useCallback((newPayMethod) => {
    setOrder((atualOrder) => {
      if (atualOrder) {
        const newOrder = atualOrder;
        newOrder.payment_mode = newPayMethod;
        newOrder.card_flag = null;
        return { ...newOrder };
      }
      return atualOrder;
    });
  }, []);

  const changeCardFlag = useCallback((newCardFlag) => {
    setOrder((atualOrder) => {
      if (atualOrder) {
        const newOrder = atualOrder;
        newOrder.card_flag = newCardFlag;
        return { ...newOrder };
      }
      return atualOrder;
    });
  }, []);

  const changeCpf = useCallback((newCpf) => {
    setOrder((atualOrder) => {
      if (atualOrder) {
        const newOrder = atualOrder;
        newOrder.cpf = newCpf;
        return { ...newOrder };
      }
      return atualOrder;
    });
  }, []);

  const changePhone = useCallback((newPhone) => {
    const maskText = MaskPhone(newPhone);

    setOrder((atualOrder) => {
      if (atualOrder) {
        const newOrder = atualOrder;
        newOrder.phone = maskText;
        return { ...newOrder };
      }
      return atualOrder;
    });
    editPhone(newPhone);
  }, []);

  const changeThing = useCallback((text) => {
    const correctText = text.replace(/\D+/g, "");
    const correctNumber =
      correctText !== "" ? `${Number.parseInt(text.replace(/\D+/g, ""))}` : 0;
    const maskText = correctText !== "" ? `R$ ${correctNumber}` : "R$ 0";
    setThing(maskText);
  }, []);

  const validateValueMin = useCallback(
    (restaurant) => {
      let priceTotal = 0;

      order?.items.forEach((item, indexItem) => {
        priceTotal += calcItem(item, indexItem) * item.qnt;
      });
      // if (order?.withdrawal === 'delivery') priceTotal += deliveryValue

      return priceTotal >= restaurant.settings.minimum_order_amount;
    },
    [order],
  );

  const verifyCard = useCallback(
    (cardType, flag) => {
      const attribute = `payment_${cardType}_${flag}`;
      const restaurantAny = restaurant;
      return restaurantAny.settings[attribute];
    },
    [restaurant],
  );

  const copyToClipboard = (key) => {
    navigator.clipboard.writeText(restaurant.general_settings.default_pix_key);
    toast.success("Chave PIX copiada com sucesso!");
  };

  const removeItem = useCallback((posItem) => {
    setOrder((atualOrder) => {
      const newOrder = JSON.parse(JSON.stringify(atualOrder));
      newOrder.items.splice(posItem, 1);
      return { ...newOrder };
    });
    setConfirmDestroy(false);
  }, []);

  const removeOrder = () => {
    setOrder((atualOrder) => {
      const newOrder = JSON.parse(JSON.stringify(atualOrder));
      newOrder.items = [];
      return { ...newOrder };
    });
    setConfirmDestroy(false);
    SessionService.removeItem("order");
    setShowCart(false);
    navigate(ROUTES.RESTAURANT(restaurantId));
  };

  const addChangeQnt = useCallback((posItem, newQtd) => {
    setPosItemSelected(posItem);
    setOrder((atualOrder) => {
      const newOrder = JSON.parse(JSON.stringify(atualOrder));

      if (newQtd === 0) {
        if (newOrder.items.length > 1) {
          setFuncConfirm("item");
          setTextConfirm("Deseja remover este produto?");
        } else {
          setFuncConfirm("order");
          setTextConfirm("Deseja excluir o seu pedido?");
        }
        setConfirmDestroy(true);
      } else newOrder.items[posItem].qnt = newQtd;

      return { ...newOrder };
    });
  }, []);

  const changeName = useCallback((value) => {
    setName(value);
  }, []);

  const changeTableNumber = useCallback(
    (tableNumber) => {
      setOrder((atualOrder) => {
        if (atualOrder) {
          return { ...atualOrder, tableNumber };
        }

        return atualOrder;
      });
    },
    [setOrder],
  );

  const getUserInfo = async () => {
    const localUser = LocalService.getItem("user");

    if (localUser) {
      return localUser.id;
    } else {
      const newAccountResponse = await createTempAccount(name);

      if (!newAccountResponse.success) {
        toast.error("Erro ao criar conta temporária.")
        return;
      }

      LocalService.addItem("accessToken", newAccountResponse.data.token);
      LocalService.addItem("user", newAccountResponse.data.info);
      return newAccountResponse.data.info.id;
    }
  };

  const onFinishOrder = async () => {
    const correctThing = thing.replace(/\D/g, "");
    const phone = order?.phone?.replace(/\D/g, "");

    if (!phone) {
      return toast.error("Informe o seu telefone.");
    }

    if (order?.withdrawal === "delivery" && !address) {
      return toast.error("Selecione um endereço de entrega.");
    }

    if (order?.withdrawal === "balcony" && !order.tableNumber) {
      return toast.error("Informe o número da mesa.");
    } else if (order.withdrawal === undefined) {
      return toast.error("Selecione um método de entrega.");
    } else if (!name || name == "") {
      return toast.error("Informe o seu nome.");
    } else if (!phone && order && order.phone?.length === 0) {
      return toast.error("Informe o seu telefone.");
    } else if (phone < 17) {
      return toast.error("Informe seu telefone neste formato (XX) XXXX-XXXX.");
    } else if (!phone && order && order.phone.length < 10) {
      return toast.error("Informe seu telefone neste formato (XX) XXXX-XXXX.");
    } else if (order?.payment_mode === "cash" && !thing) {
      return toast.error("Informe para quanto será o troco.");
    } else if (
      order?.payment_mode === "cash" &&
      parseInt(correctThing) < totalOrderValue
    ) {
      return toast.error(
        "O valor do troco deve ser maior que o valor do pedido.",
      );
    } else if (!order?.payment_mode) {
      return toast.error("Selecione um método de pagamento.");
    } else if (
      (order?.payment_mode === "debit_card" ||
        order?.payment_mode === "credit_card") &&
      !order.card_flag
    ) {
      return toast.error("Selecione a bandeira do cartão.");
    } else if (
      order?.withdrawal === "delivery" &&
      !validateValueMin(restaurant)
    ) {
      return toast.error(
        `Valor mínimo de pedido não atingido. ${MaskMoney(restaurant.settings.minimum_order_amount)}`,
      );
    } else {
      setLoadingCreateOrder(true);
      try {
        const accountId = await getUserInfo();
        if (!accountId) return;
        const {
          card_flag,
          cpf,
          cpfInNote,
          delivery_value,
          discount_value,
          items,
          order_value,
          payment_mode,
          withdrawal,
          status,
          tableNumber,
        } = order;
        const data = {
          address,
          card_flag,
          thing: correctThing,
          cpf: cpf?.replace(/\D/g, ""),
          cpfInNote,
          delivery_value,
          discount_value,
          items,
          order_value,
          payment_mode,
          phone: order.phone.replace(/\D/g, ""),
          useCashback: false,
          withdrawal,
          status,
          tableNumber,
        };
        const body = {
          order: {
            ...data,
            order_value: totalOrderValue < 0 ? 0 : totalOrderValue,
            delivery_value: restaurantDeliveryPrice,
            friend_user_id: accountId,
            restaurant_id: restaurant.id,
            cpfInNote: cpfInNote ? cpfInNote : false,
          },
        };

        const result = await API.createOrder(body);

        if (result.data.id) {
          setOrder(null);
          setShowCart(false);

          SessionService.removeItem("order");

          const socket = getSocket();
          if (!socket) return;

          socket.emit("new-order", {
            restaurant,
            order: {
              id: result.data.id,
            },
          });
          SessionService.reset();
          setIsOrderFinishedSuccess(true);
          navigate(ROUTES.ORDERS);
        } else {
          throw new Error("Erro ao finalizar o pedido.");
        }
      } catch (err) {
        console.log(err);
        if (!!err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error(
            "Houve um erro ao finalizar seu pedido. Tente novamente mais tarde.",
          );
        }
      } finally {
        setLoadingCreateOrder(false);
      }
    }
  };

  const setDefaultDataForBalcony = () => {
    setOrder((atualOrder) => {
      if (atualOrder) {
        const newOrder = atualOrder;
        newOrder.phone = "99999999999";
        newOrder.payment_mode = getPaymentMethodForBalcony();
        newOrder.card_flag = getFlagForBalcony();
        console.log(atualOrder);

        return { ...newOrder };
      }
      return atualOrder;
    });
  };

  const getPaymentMethodForBalcony = () => {
    const paymentMethods = [
      { key: "payment_credit", value: true },
      { key: "payment_debit", value: true },
      { key: "payment_pix", value: true },
      { key: "payment_cash", value: true },
    ];

    for (const method of paymentMethods) {
      const keys = Object.keys(settings);
      console.log(settings);
      for (const key of keys) {
        if (key.startsWith(method.key) && settings[key] === method.value) {
          if (
            key.startsWith("payment_credit") ||
            key.startsWith("payment_debit")
          ) {
            return "credit_card";
          } else if (key.startsWith("payment_pix")) return "pix";
          return "cash";
        }
      }
    }

    return null;
  };

  const getFlagForBalcony = () => {
    const keys = Object.keys(settings);
    for (const key of keys) {
      if (key.startsWith("payment_credit") || key.startsWith("payment_debit")) {
        const prefix = "payment_credit_card_";
        if (key.startsWith(prefix)) {
          return key.substring(prefix.length);
        }
        const debitPrefix = "payment_debit_card_";
        if (key.startsWith(debitPrefix)) {
          return key.substring(debitPrefix.length);
        }
        return null;
      }
    }
    return null;
  };

  const findDeliveryPrice = async () => {
    setRestaurantDeliveryPrice(
      await getDeliveryPriceByCep(restaurant.delivery_prices),
    );
  };

  return (
    <CartContext.Provider
      value={{
        calcChooses,
        clickToEdit,
        deliveryType,
        setDeliveryType,
        addChangeQnt,
        removeOrder,
        removeItem,
        copyToClipboard,
        verifyCard,
        changeThing,
        changePhone,
        changeCpf,
        changeCardFlag,
        changePayMethod,
        onFinishOrder,
        calcOrderProductsValue,
        loadingCreateOrder,
        setLoadingCreateOrder,
        thing,
        setThing,
        confirmDestroy,
        setConfirmDestroy,
        textConfirm,
        setTextConfirm,
        funcConfirm,
        setFuncConfirm,
        posItemSelected,
        setPosItemSelected,
        controlRender,
        setControlRender,
        calcItem,
        totalOrderValue,
        name,
        phone,
        editPhone,
        changeName,
        findDeliveryPrice,
        changeTableNumber,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCartContext = () => useContext(CartContext);
